import { BillingDialogConfig } from '../interface/billing.interface';
import { UserRole } from '../interface/user.interface';

const userRole = UserRole;

export const billingDialogConfigArray: BillingDialogConfig[] = [
  {
    responseType: 'NO_BILLING_MODEL',
    title: 'No Billing Model',
    message: "Your company's billing set up does not seem to complete",
    actionMessage: {
      message: `Please contact PropMix support at <a href="mailto:support@propmix.io">support@propmix.io</a> to complete the setup or contact your company's administrator.`,
    },
    actions: [{ displayValue: 'Cancel', type: 'cancel' }],
    icon: 'contract_delete',
    iconColor: 'warn',
  },
  {
    responseType: 'NO_PAYMENT_METHOD',
    title: 'No Payment Method for Company',
    message:
      'A payment method has not been set up yet. A default payment method is required for the company before you can place this order.',
    actionMessage: {
      message: "Please contact your company's administrator.",
      roles: [
        userRole.APPRAISER,
        userRole.APPRAISAL_ASSISTANT,
        userRole.AMC_MANAGER,
        userRole.MANAGER,
        userRole.BROKER,
        userRole.CHIEF_APPRAISER,
        userRole.INSPECTOR,
        userRole.REVIEWER,
        userRole.SUPERVISORY_APPRAISER,
      ],
    },
    actions: [
      { displayValue: 'Cancel', type: 'cancel' },
      {
        displayValue: 'Add Payment Method',
        type: 'addPaymentMethod',
        roles: [userRole.APP_ADMIN, userRole.COMPANY_ADMIN],
      },
    ],
    icon: 'credit_card_off',
    iconColor: 'warn',
  },
  {
    responseType: 'UNKNOWN_ORDER_TYPE',
    title: 'Order Type Not Recognized',
    message: 'Something seems to be wrong at our end. We do not have a billing model setup for that Order Type.',

    actionMessage: {
      message: `Please contact support at <a href="mailto:support@propmix.io">support@propmix.io</a> `,
    },
    actions: [{ displayValue: 'Cancel', type: 'cancel' }],
    icon: 'unknown_document',
    iconColor: 'warn',
  },
  {
    responseType: 'PAYASYOUGO_RECOGNIZED',
    title: 'Confirm Order Creation',
    message: null,
    actionMessage: {
      message:
        "If you continue by clicking “Create Order”, your company's payment method will be charged the amount shown above.",
    },
    actions: [
      { displayValue: 'Cancel', type: 'cancel' },
      { displayValue: 'Create Order', type: 'createOrder' },
    ],
    icon: 'check_circle',
    iconColor: 'accent',
  },
  {
    responseType: 'MONTHLY_COVERED',
    title: 'Order Covered in Plan',
    message: 'This order is covered by your current subscription plan.',
    actions: [
      { displayValue: 'Cancel', type: 'cancel' },
      { displayValue: 'Continue', type: 'continue' },
    ],
    icon: 'check_circle',
    iconColor: 'accent',
  },
  {
    responseType: 'MONTHLY_NOT_COVERED',
    title: 'Order is not covered in Plan',
    message: 'Your monthly subscription plan does not cover this order.The order will require a one time fee.',
    actionMessage: {
      message:
        "If you continue by clicking “Make Payment & Continue”, your company's payment method will be charged the amount shown above.",
    },
    actions: [
      { displayValue: 'Cancel', type: 'cancel' },
      { displayValue: 'Make Payment & Continue', type: 'continue' },
    ],
    icon: 'error',
    iconColor: 'warn',
  },
  {
    responseType: 'MONTHLY_USAGE_EXHAUSTED_NO_PAYMENT',
    title: 'Monthly Usage Exhausted',
    message:
      'This order is covered by your current subscription plan. But you have already used up all the included orders.',
    actionMessage: {
      message:
        "If you continue by clicking “Continue”, your company's payment method will be charged the Excess Usage Fee.",
    },
    actions: [
      { displayValue: 'Cancel', type: 'cancel' },
      { displayValue: 'Continue', type: 'continue' },
    ],
    icon: 'error',
    iconColor: 'warn',
  },
  {
    responseType: 'CONTRACTUAL',
  },
];
